import MaterialModal from '@mui/material/Modal';
import './Modal.scss'
import {Box} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import {useContext} from "react";
import {I18nReactContext} from "../../../contexts/I18nContext";

const boxStyle = {
    borderRadius:'12px',
    boxShadow: 24,
    p: 3,
    bgcolor: '#fff',
    position: 'relative'
}

/**
 * Generic modal wrapper around MUI Modal with a styled content box.
 * @param {object} props - Component props
 * @param {boolean} props.open - Whether the modal is open
 * @param {Function} props.onClose - Callback invoked on close (X click, backdrop click, ESC)
 * @param {React.ReactNode} props.children - Modal content
 * @param {boolean} [props.hideCloseButton=false] - When true, the close (X) button is not rendered
 * @returns {JSX.Element} The Modal component
 */
export const Modal = ({open, onClose, children, hideCloseButton = false}) => {
    const {isRtl} = useContext(I18nReactContext);
    return <MaterialModal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
    >
        <div className={`modalAbsoluteWrapper ${isRtl ? 'rtl' : 'ltr'}`}>
            <Box sx={boxStyle} className="ModalContentBox">
                {!hideCloseButton && <div className="ModalX" onClick={onClose}><CloseIcon/></div>}
                <div className="ModalBox">
                    {children}
                </div>
            </Box>
        </div>

    </MaterialModal>
}